import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Modal,
  Typography,
  Button,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import useStyles from './styles';

function SuccessModal({ open, onClose }) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose} disableScrollLock>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          maxWidth: 440,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          borderRadius: 1,
          outline: 'none',
        }}
      >
        <Box className={classes.modalSuccessIcon}>
          <CheckCircleIcon sx={{ fontSize: 40 }} />
        </Box>
        <Typography variant="h6" component="h2" align="center" gutterBottom fontWeight="bold">
          Tu cuenta ha sido creada con éxito
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center" sx={{ mb: 3 }}>
          Nuestros administradores configurarán tu
          cuenta para que puedas ver el contenido de tus causas.
        </Typography>
        <Button
          fullWidth
          variant="contained"
          className={classes.modalButton}
          onClick={onClose}
        >
          Entendido
        </Button>
      </Box>
    </Modal>
  );
}

SuccessModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SuccessModal;
